@if (inline || isOpen) {
<div [class.modal-fullscreen]="!inline">
  @if (!inline) {
  <div class="modal-header">
    <button type="button" class="btn btn-outline-secondary" (click)="close()">Retour</button>
    <div class="header-title" style="margin-left: 20px; font-weight: bold;">Templates</div>
  </div>
  }

  <div class="modal-body-container" [class.inline]="inline">
    <!-- Sidebar -->
    <div class="sidebar">
      <div class="sidebar-header">
        <button class="btn btn-sm btn-primary w-100" (click)="startCreateFolder()" *ngIf="!isCreatingFolder">
          <i class="bi bi-folder-plus"></i> Nouveau Dossier
        </button>
        <div *ngIf="isCreatingFolder" class="create-folder-form">
          <input type="text" [(ngModel)]="newFolderName" class="form-control form-control-sm mb-3"
            placeholder="Nom du dossier" (keyup.enter)="createFolder()">
          <div class="d-flex justify-content-between">
            <button nbButton appearance="filled" size="small" (click)="createFolder()">OK</button>
            <button nbButton appearance="outline" size="small" (click)="cancelCreateFolder()">X</button>
          </div>
        </div>
      </div>

      <ul class="folder-list">
        <li [class.active]="!selectedFolder" (click)="selectFolder(null)">
          <i class="bi bi-grid"></i> Tous les templates
        </li>
        @for (folder of folders; track folder.id) {
        <li [class.active]="selectedFolder?.id === folder.id" (click)="selectFolder(folder)">
          <div class="d-flex justify-content-between align-items-center w-100">
            <span><i class="bi bi-folder"></i> {{ folder.name }}</span>
            <i class="bi bi-trash text-danger delete-icon" (click)="deleteFolder(folder, $event)"></i>
          </div>
        </li>
        }
      </ul>
    </div>

    <!-- Main Content -->
    <div class="main-content">
      <!-- Search bar -->
      <div class="search-container">
        <input type="text" [(ngModel)]="searchQuery" placeholder="Rechercher un template..." class="search-input">
      </div>

      <!-- Grille des templates -->
      <div class="template-grid">
        @if (showStripoImport && inline) {
        <div class="template-item import-item" (click)="openStripoImportDialog()">
          <div class="import-placeholder">
            <i class="bi bi-cloud-upload"></i>
          </div>
          <div class="template-item-details">
            <div class="template-title">Importer html</div>
          </div>
        </div>
        }
        @for (template of filteredTemplates; track template.id) {
        <div class="template-item" (click)="selectTemplate(template)">
          <div class="image-container">
            <img [src]="template.preview" alt="{{template.name}}" class="template-image">
          </div>

          <div class="template-item-details">
            <div class="template-title" title="{{ template.name }}">{{ template.name }}</div>
            @if (template.folder) {
            <div class="template-folder-badge">
              <i class="bi bi-folder-fill"></i> {{ getFolderName(template.folder) }}
            </div>
            }
          </div>

          <div class="template-actions" (click)="$event.stopPropagation()">
            <div ngbDropdown placement="top-right" class="d-inline-block position-static">
              <button nbButton ghost class="menu-button" ngbDropdownToggle>
                <i class="bi bi-three-dots"></i>
              </button>
              <div ngbDropdownMenu>
                <h6 class="dropdown-header">Déplacer vers...</h6>
                <button ngbDropdownItem (click)="moveTemplate(template, null)">
                  <i class="bi bi-folder-x"></i> Dossier principal
                </button>
                <div class="dropdown-divider"></div>
                @for (folder of folders; track folder.id) {
                <button ngbDropdownItem (click)="moveTemplate(template, folder)">
                  <i class="bi bi-folder"></i> {{ folder.name }}
                </button>
                }
              </div>
            </div>
          </div>
        </div>
        }
      </div>

      @if (filteredTemplates.length === 0) {
      <div class="no-results-message">
        Aucun template ne correspond à votre recherche @if(selectedFolder) { dans ce dossier }.
      </div>
      }
    </div>
  </div>
</div>
}

@if (showStripoDialog) {
<div class="stripo-dialog-overlay" (click)="cancelStripoImport()">
  <div class="stripo-dialog" (click)="$event.stopPropagation()">
    <h6 class="stripo-dialog-title">Importer depuis Stripo</h6>
    <div class="mb-3">
      <label class="form-label">ID de l'email Stripo <span class="text-danger">*</span></label>
      <input type="text" class="form-control" [(ngModel)]="stripoEmailId" placeholder="ex: 123456789">
    </div>
    <div class="mb-4">
      <label class="form-label">Nom du template (optionnel)</label>
      <input type="text" class="form-control" [(ngModel)]="stripoImportName" placeholder="Mon email">
    </div>
    <div class="d-flex justify-content-end gap-2">
      <button class="btn btn-outline-secondary" (click)="cancelStripoImport()" [disabled]="isImporting">Annuler</button>
      <button class="btn btn-primary" (click)="confirmStripoImport()" [disabled]="!stripoEmailId.trim() || isImporting">
        @if (isImporting) { Importation en cours... } @else { Importer }
      </button>
    </div>
  </div>
</div>
}
